import { useLike } from "@/hooks/useLike";
import { TParentType } from "@/lib/community";
import { Heart, ThumbsUp } from "lucide-react";
import { cn } from "../../lib/utils";

interface IProps {
  parentId: string | number;
  className?: string;
  parentType: TParentType;
}

export default function LikeButton({
  parentId,
  className,
  parentType,
}: IProps) {
  const { isLiked, likeCount, toggleLike, loading } = useLike(
    parentId,
    parentType
  );

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        toggleLike();
      }}
      disabled={loading}
      className={cn(
        "flex items-center justify-center gap-1 text-base outline-none",
        className
      )}
      aria-label={isLiked ? "Убрать лайк" : "Поставить лайк"}
      type="button"
    >
      <ThumbsUp
        size={16}
        className={cn(
          isLiked ? "fill-blue-500 text-blue-600" : "text-gray-400"
        )}
        style={{
          transition: "color 0.15s, fill 0.15s",
        }}
      />
      <span className="font-semibold text-sm">{likeCount}</span>
    </button>
  );
}
